let pendingCapturedExplorePayload = null;
let pendingCapturedMomentPayload = null;

export function setPendingCapturedExploreFile(fileOrPayload, metadata = {}) {
  if (!fileOrPayload) {
    pendingCapturedExplorePayload = null;
    return;
  }

  if (fileOrPayload instanceof File) {
    pendingCapturedExplorePayload = {
      file: fileOrPayload,
      metadata: metadata || {},
    };
    return;
  }

  const normalizedFile = fileOrPayload?.file instanceof File ? fileOrPayload.file : null;
  if (!normalizedFile) {
    pendingCapturedExplorePayload = null;
    return;
  }

  pendingCapturedExplorePayload = {
    file: normalizedFile,
    metadata: fileOrPayload?.metadata || metadata || {},
  };
}

export function consumePendingCapturedExploreFile() {
  const payload = pendingCapturedExplorePayload || null;
  pendingCapturedExplorePayload = null;
  return payload;
}

export function clearPendingCapturedExploreFile() {
  pendingCapturedExplorePayload = null;
}

export function setPendingCapturedMomentFile(fileOrPayload, metadata = {}) {
  if (!fileOrPayload) {
    pendingCapturedMomentPayload = null;
    return;
  }

  if (fileOrPayload instanceof File) {
    pendingCapturedMomentPayload = {
      file: fileOrPayload,
      metadata: metadata || {},
    };
    return;
  }

  const normalizedFile = fileOrPayload?.file instanceof File ? fileOrPayload.file : null;
  if (!normalizedFile) {
    pendingCapturedMomentPayload = null;
    return;
  }

  pendingCapturedMomentPayload = {
    file: normalizedFile,
    metadata: fileOrPayload?.metadata || metadata || {},
  };
}

export function consumePendingCapturedMomentFile() {
  const payload = pendingCapturedMomentPayload || null;
  pendingCapturedMomentPayload = null;
  return payload;
}

export function clearPendingCapturedMomentFile() {
  pendingCapturedMomentPayload = null;
}
